import PropTypes from "prop-types"
import { Avatar, ListItemAvatar, CircularProgress, ListItem, ListItemText } from "@mui/material"
import { Work } from "@mui/icons-material"
import { appendTimestamp } from "modules/server-notifications/helpers"

function Waiting({ message, targetName, createdAt }) {
  return <ListItem className="waiting">
    <ListItemAvatar>
      <Avatar>
        <Work />
      </Avatar>
    </ListItemAvatar>
    <CircularProgress
      style={{ position: "absolute" }}
    />
    <ListItemText primary={message} secondary={appendTimestamp(targetName, createdAt)} />
  </ListItem>
}

Waiting.propTypes = {
  message: PropTypes.string.isRequired,
  targetName: PropTypes.string.isRequired,
  createdAt: PropTypes.string.isRequired,
}

export default Waiting
